module.exports = __webpack_public_path__ + "img/style_3_23.c33099fd.png";